@import (reference) '../../../../../../constants/spacing.module.less';

.sort-controls {
  align-items: center;
  flex-wrap: wrap;
}

.sort-label {
  color: var(--default--text-color--9);
}

.sort-pill {
  padding: @space-4 @space-12;
  border-radius: 14px;
  border: 1px solid var(--default--border-color--10);
  font-size: 13px;
  color: var(--default--text-color--9);
  cursor: pointer;
}

.sort-pill-active {
  background: var(--brand--primary--color);
  border-color: var(--brand--primary--color);
  color: #fff;
  font-weight: 600;
}

.loading-state {
  align-items: center;
  padding: @space-24 0;
}

.empty-state {
  padding: @space-24 0;
  align-items: center;
}

.step-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: @space-8;
}
